import UniqueSellingPoint from '@theme/components/shop/UniqueSellingPoint'

export default {
  components: {
    UniqueSellingPoint,
  },
  computed: {
    uniqueSellingPoints() {
      if (this.$themeSettings.components.UniqueSellingPoints.enable !== true) {
        return []
      }

      const cmsUniqueSellingPoints = this.cmsUniqueSellingPoints
      if (cmsUniqueSellingPoints.length > 0) {
        return cmsUniqueSellingPoints
      }

      return this.translatedUniqueSellingPoints
    },
    cmsUniqueSellingPoints() {
      return (this.$store.state.globals.uspBlocks || [])
        .map(point => ({
          description: point.description,
          iconImage: point.icon && point.icon[0] ? point.icon[0] : null,
          link: point.link && point.link[0] && point.link[0].link_type ? point.link[0] : null,
          title: point.title,
        }))
        .filter(point => point.title)
    },
    translatedUniqueSellingPoints() {
      const points = this.$t('globals.UniqueSellingPoints')
      if (typeof points !== 'object' || !points.length) {
        return []
      }

      return points.map(point => ({
        ...point,
        icon: this.pointsIcons[point.icon],
      }))
    },
    pointsIcons() {
      return {
        'delivery-truck': require('@icon/delivery-truck.svg?raw'),
        package: require('@icon/package.svg?raw'),
        phone: require('@icon/phone.svg?raw'),
        'shield-o': require('@icon/shield-o.svg?raw'),
        store: require('@icon/store.svg?raw'),
        success: require('@icon/success.svg?raw'),
        waranty: require('@icon/shield-o.svg?raw'),
        warehouse: require('@icon/store.svg?raw'),
      }
    },
  },
}
